import type { PreviewMessage, WidgetPreviewConfig } from './types';
import { MessageBubble, type MessageGroupPosition } from './message-bubble';
import styles from './widget-preview.module.scss';

interface MessageListProps {
  messages: PreviewMessage[];
  config: WidgetPreviewConfig;
}

const getGroupPosition = (messages: PreviewMessage[], index: number): MessageGroupPosition => {
  const sender = messages[index].sender;
  const samePrevious = messages[index - 1]?.sender === sender;
  const sameNext = messages[index + 1]?.sender === sender;

  if (samePrevious && sameNext) return 'middle';
  if (!samePrevious && sameNext) return 'first';
  if (samePrevious && !sameNext) return 'last';
  return 'single';
};

export const MessageList = ({ messages, config }: MessageListProps) => (
  <div className={styles.messageList}>
    {messages.map((message, index) => (
      <MessageBubble
        key={message.id}
        message={message}
        groupPosition={getGroupPosition(messages, index)}
        config={config}
      />
    ))}
  </div>
);
